import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { Box, Container, makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Page from "src/components/Page";
import Results from "./Results";
import Toolbar from "./Toolbar";
import SmstextService from "../../../services/smstext.service";
import { loggedInUserState } from "../../../services/state";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const SmstextListView = () => {
  const classes = useStyles();
  const [smstexts, setSmstexts] = useState([]);
  const navigate = useNavigate();
  const currentUser = useRecoilValue(loggedInUserState);

  useEffect(() => {
    if (!currentUser) {
      navigate("/login", { replace: true });
    } else {
      SmstextService.getSmstexts().then((result) => {
        setSmstexts(result.data);
      });
    }
  }, []);

  return (
    <Page className={classes.root} title="Texty SMS">
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Results smstexts={smstexts} />
        </Box>
      </Container>
    </Page>
  );
};

export default SmstextListView;
